"use client"

import { Calendar, X } from "lucide-react"

const STORAGE_KEY = "preheader-dismissed"

export function PreHeader() {
    const handleDismiss = () => {
        localStorage.setItem(STORAGE_KEY, "true")
        document.getElementById("pre-header-banner")?.remove()
    }

    return (
        <>
            {/* INLINE SCRIPT: Prevents flash/CLS without opting into dynamic rendering by checking localStorage during HTML Parse */}
            <script
                suppressHydrationWarning
                dangerouslySetInnerHTML={{
                    __html: `if(localStorage.getItem("${STORAGE_KEY}")==="true"){document.documentElement.classList.add("hide-preheader")}`
                }}
            />
            <style suppressHydrationWarning>{`
                .hide-preheader #pre-header-banner { display: none !important; }
            `}</style>
            
            <div id="pre-header-banner" className="hidden sm:block relative z-[60] w-full bg-white/[0.02] backdrop-blur-sm transition-all duration-300">
                <div className="container mx-auto px-4">
                    <div className="flex items-center justify-center gap-3 h-9 text-xs sm:text-sm">
                        {/* Status Indicator (Pure CSS static neon dot, no heavy JS/SVG animation) */}
                        <span className="flex items-center gap-2 text-muted-foreground">
                            <span className="relative flex h-2 w-2">
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)]" />
                            </span>
                            <span className="hidden sm:inline">Available for Q1 Projects</span>
                            <span className="sm:hidden">Available</span>
                        </span>

                        <span className="text-muted-foreground/50">•</span>

                        {/* CTA Link */}
                        <a
                            href="https://cal.com/hamid-ayub/discovery"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1.5 font-medium text-foreground hover:text-primary transition-colors group"
                        >
                            <Calendar className="w-3.5 h-3.5" />
                            <span className="underline-offset-4 group-hover:underline">
                                Book a 30-min Discovery Call
                            </span>
                            <span className="group-hover:translate-x-0.5 transition-transform">→</span>
                        </a>

                        {/* Dismiss Button */}
                        <button
                            onClick={handleDismiss}
                            className="absolute right-2 sm:right-4 p-1 text-muted-foreground/50 hover:text-muted-foreground transition-colors"
                            aria-label="Dismiss"
                        >
                            <X className="w-3.5 h-3.5" />
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
